import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getUserStatusAction } from 'root-redux/actions/user'
import { selectUUID } from 'root-redux/selects/user'

export const useSetUserStatus = () => {
  const dispatch = useDispatch()
  const uuid = useSelector(selectUUID)

  useEffect(() => {
    if (uuid) {
      dispatch(getUserStatusAction(uuid))
    }
  }, [dispatch, uuid])
}
